import { render, staticRenderFns } from "./chooseDevelopModal.vue?vue&type=template&id=b4d1fc3c&scoped=true"
import script from "./chooseDevelopModal.vue?vue&type=script&lang=js"
export * from "./chooseDevelopModal.vue?vue&type=script&lang=js"
import style0 from "./chooseDevelopModal.vue?vue&type=style&index=0&id=b4d1fc3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d1fc3c",
  null
  
)

export default component.exports